import * as React from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import { TransitionProps } from '@mui/material/transitions';
import { useHistory } from 'react-router-dom';
import Stickers from './Stickers';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const StickersPopup = ({ showStickers, toggleStickers, setStickerUrl, setSticker }: any) => {
    const history = useHistory();
    return (
        <>
            <div>
                <Dialog
                    className="Stickers_modal"
                    sx={{ "& .MuiDialog-paper": { backgroundColor: "#f5f4f9" } }}
                    fullScreen
                    disableEscapeKeyDown={true}
                    TransitionComponent={Transition}
                    open={showStickers}
                    onClose={history.goBack}
                >
                    <div className='Stickers-container' style={{ overflowY: "auto" }}>
                        <Stickers toggleStickers={toggleStickers} setStickerUrl={setStickerUrl} setSticker={setSticker} />
                    </div>
                </Dialog>
            </div>
        </>


    )
}


export default StickersPopup;